import { localStorage } from 'Lib/storage';
import uuid from 'Lib/utils/uuid';

const KEY_UUID = 'TinderWeb/uuid';

let deviceId = localStorage.getItem(KEY_UUID);
let isDeviceIdNew: boolean = false;

if (!deviceId) {
  deviceId = uuid();
  localStorage.setItem(KEY_UUID, deviceId);
  isDeviceIdNew = true;
}

export const isRecognizedDevice = (): boolean => {
  const isNew = isDeviceIdNew;
  isDeviceIdNew = false;
  return !isNew;
};

export default () => deviceId;
